/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import {
  Container,
  FormHelperText,
  AddBox,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  UserShared,
  StyledCrudTable,
} from './styles';
import { isEmpty } from 'lodash';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';
import Substitute from '../../forms/substitute';
import moment from 'moment';

const SelectDentistControl = ({
  data,
  className,
  id,
  enabled,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible,
  disabled,
  required,
  substituteDentistId,
  replacedDentistId,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [substitute, setSubstitute] = useState({});
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({});
  const [searchBy, setSearchBy] = useState('');
  const columns = Substitute.alternativeTableSchema;

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    restApiClient.substitute
      .getAllByReplacement(
        substituteDentistId,
        replacedDentistId,
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .like('id', searchBy)
              .or()
              .like('name', searchBy)
              .toString()
          : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.substitute.findById(data).then((e) => {
        setSubstitute(e.data);
        handleChange?.(path, e.data?.id);
      });
    } else {
      setSubstitute({});
    }
  }, [handleChange, path, data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          disabled={!enabled}
          error={!isEmpty(errors)}
          adornment={<UserShared />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label={label}
          InputLabelProps={{
            readOnly: true,
          }}
          required={required}
          value={
            !isEmpty(substitute)
              ? moment(substitute?.replacementDate).format('DD/MM/YYYY')
              : ''
          }
          helperText={
            !isEmpty(errors) ? (
              <FormHelperText error>{`${errors}`}</FormHelperText>
            ) : (
              ''
            )
          }
        />
      </Container>

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <StyledCrudTable
            title={'Seleção de Substituição'}
            modelActions={Substitute.actions}
            columns={columns}
            rows={rows}
            page={page}
            setPage={(page) => setPage(page)}
            rowsPerPage={rowsPerPage}
            availableRowsPerPage={[3]}
            setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
            onOrderByChange={(orderBy) => setOrderby(orderBy)}
            orderBy={orderBy}
            setOrderBy={(value) => setOrderby(value)}
            searchBy={searchBy}
            setSearchBy={(value) => setSearchBy(value)}
            actions={{
              insert: {
                icon: <AddBox />,
                onClick: (id, data) => {
                  setSubstitute(data);
                  handleChange?.(path, id);
                  onSuccess?.(id);
                  handleClose();
                },
                title: 'Vincular',
                allowedActions: [Substitute.actions.getAll],
              },
            }}
            customCellRenderers={{
              replacementDate: {
                renderer: (index, value) => {
                  return moment(value).format('DD/MM/YYYY');
                },
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Hidden>
  );
};

export default SelectDentistControl;
